export const categories = [
  { slug: 'wanghong-fanche', name: '网红翻车', icon: 'ri-alert-line', description: '网红主播翻车现场，最新塌房事件全纪录', color: 'accent' },
  { slug: 'mingxing-bagua', name: '明星八卦', icon: 'ri-star-line', description: '娱乐圈明星最新八卦爆料，一手消息速递', color: 'primary' },
  { slug: 'fancha-shipin', name: '反差视频', icon: 'ri-contrast-2-line', description: '人前人后反差巨大的精彩视频合集', color: 'secondary' },
  { slug: 'meiri-dasai', name: '每日大赛', icon: 'ri-fire-line', description: '每日最热门话题PK，看看今天谁最火', color: 'accent' },
  { slug: 'he-liao-shendu', name: '黑料深度', icon: 'ri-search-eye-line', description: '深度挖掘不为人知的幕后黑料', color: 'primary' },
  { slug: 'chigua-shequ', name: '吃瓜社区', icon: 'ri-group-line', description: '吃瓜群众聚集地，一起讨论最新大瓜', color: 'secondary' },
];

export const hotTags = [
  '顶流塌房', '直播翻车', '恋情曝光', '综艺争议', '选秀黑幕', '带货假货',
];